import type { IntegrationName } from "@tellescope/tanstack-query";

/** Features that correspond to a navigable page. */
export const FEATURE_PAGE_NAMES = [
  "dashboard",
  "ai",
  "contacts",
  "tickets",
  "calendar",
  "templates",
  "vitals",
  "settings",
  "messaging",
  "team-chat",
  "call",
] as const;
export type FeaturePageName = (typeof FEATURE_PAGE_NAMES)[number];

/** Non-page capabilities a plan can grant (gate behaviors, not routes). */
export const FEATURE_CAPABILITY_NAMES = [
  "table_views",
  "eligibility",
  "orders",
  "encounters",
  "files",
  "forms",
  "content",
  "medications",
  "payments",
] as const;
export type FeatureCapabilityName = (typeof FEATURE_CAPABILITY_NAMES)[number];

export type FeatureName = FeaturePageName | FeatureCapabilityName;

/** Every feature name (pages + capabilities), for exhaustive iteration. */
export const FEATURE_NAMES: readonly FeatureName[] = [...FEATURE_PAGE_NAMES, ...FEATURE_CAPABILITY_NAMES];

export interface FeatureAvailability {
  /** Whether the feature is part of the plan. Unknown plans grant everything (preserves current behavior). */
  enabled: boolean;
  /** `"ready"` when usable now; `"setup-required"` when the powering integration isn't set up. */
  status: "ready" | "setup-required";
  /** The integration that powers this feature, when one does — the link target for "finish setup". */
  integration?: IntegrationName;
}
